import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ExternalLinkTemplate } from "~/features/externalLink/ExternalLinkTemplate";

const externalLinkSearchSchema = z.object({
  /** 表示する外部URL */
  url: z.string(),
  /** ヘッダーに表示するタイトル。未指定なら空欄。 */
  title: z.string().optional(),
});

// _authenticated レイアウトの上に全画面オーバーレイで重ねる
const ExternalLinkPage = () => (
  <div className="fixed inset-0 z-40 bg-white">
    <ExternalLinkTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/external-link")({
  validateSearch: externalLinkSearchSchema,
  component: ExternalLinkPage,
});
